import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import 'instantsearch.css/themes/satellite.css';
import 'hint.css/hint.css';
import algoliasearch from 'algoliasearch/lite';
import {
    InstantSearch,
    Configure,
    ClearRefinements,
    SortBy,
    Pagination, ScrollTo
} from 'react-instantsearch-dom';
import SearchBoxContainer from "./components/SearchBoxContainer";
import Hits from "./components/Hits";
import qs from 'qs';
import { formatDuration } from "./util";
import Refinement from "./components/Refinement";

const searchClient = algoliasearch(
    process.env.REACT_APP_ALGOLIA_SEARCH_APP_ID,
    process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY
);

const DEBOUNCE_TIME = 400;

const createURL = state => `?${qs.stringify(state)}`;

const searchStateToUrl = ({ location }, searchState) =>
    searchState ? `${location.pathname}${createURL(searchState)}` : '';

const urlToSearchState = ({ search }) => qs.parse(search.slice(1));

const App = ({ location, history }) => {
    const [searchState, setSearchState] = useState(urlToSearchState(location));
    const [debouncedSetState, setDebouncedSetState] = useState(null);

    const onSearchStateChange = updatedSearchState => {
        clearTimeout(debouncedSetState);

        setDebouncedSetState(
            setTimeout(() => {
                history.push(
                    searchStateToUrl({ location }, updatedSearchState),
                    updatedSearchState,
                );
            }, DEBOUNCE_TIME)
        );

        setSearchState(updatedSearchState);
    };

    return (
        <InstantSearch
            searchClient={searchClient}
            indexName="courses"
            searchState={searchState}
            onSearchStateChange={onSearchStateChange}
            createURL={createURL}
        >
            <Configure
                hitsPerPage={10}
            />

            <ScrollTo>
                <div className="main-content">
                    <Pagination />
                        <Hits />
                    <Pagination />
                </div>

                <aside className="sidebar">
                    <div className="sidebar-inner">
                        <div
                            className="centered-wrapper ce_rsce_centered_wrapper_start padding-gutter first -bg-color-1 -color-inverted">
                            <h3 className="ce_headline">Précisez votre recherche</h3>
                            <div>Les résultats sont filtrés instantanément au fil de votre saisie</div>
                            <SearchBoxContainer />
                        </div>
                        <div className="ce_text block">
                            <h3>Trier</h3>

                            <SortBy
                                defaultRefinement="courses"
                                items={[
                                    { value: 'courses', label: 'Pertinence' },
                                    { value: 'courses_price_inter_asc', label: 'Prix inter croissant' },
                                    { value: 'courses_price_inter_desc', label: 'Prix inter décroissant' },
                                    { value: 'courses_price_intra_asc', label: 'Prix intra croissant' },
                                    { value: 'courses_price_intra_desc', label: 'Prix intra décroissant' },
                                    { value: 'courses_duration_hours_asc', label: 'Durée croissant' },
                                    { value: 'courses_duration_hours_desc', label: 'Durée décroissant' },
                                ]}
                            />
                            {/*<div className="text">*/}
                            {/*    <div className="wrapper">*/}
                            {/*        <p>A venir ;)</p></div>*/}
                            {/*</div>*/}
                        </div>
                        <h3>Filtrer</h3>
                        <ClearRefinements
                            translations={{
                                reset: 'Effacer tous les filtres',
                            }}
                        />

                        <Refinement
                            title="Domaine"
                            attribute="domain"
                            // defaultRefinement={getDomainFromLocation()}
                            showMore
                            showMoreLimit={100}
                        />
                        <Refinement
                            title="Sous-domaine"
                            attribute="subdomain"
                            showMore
                            showMoreLimit={100}
                        />
                        <Refinement
                            title="Certification"
                            attribute="certification"
                            showMore
                            showMoreLimit={100}
                        />
                        <Refinement
                            title="Modalités"
                            attribute="modality"
                            showMore
                            showMoreLimit={100}
                        />
                        <Refinement
                            title="Durée"
                            attribute="durationDays"
                            transformItems={items =>
                                items.map(item => {
                                    return {
                                        ...item,
                                        label: item.label <= 0
                                            ? 'nc'
                                            : formatDuration(item.label, 'j')
                                    };
                                })
                            }
                            showMore
                            showMoreLimit={100}
                        />
                    </div>
                </aside>
            </ScrollTo>
        </InstantSearch>
    );
};

export default withRouter(App);
